import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../contexts/AuthContext';
import AppHeader from './AppHeader';
import './Settings.css';

function Settings() {
  const { t, i18n } = useTranslation();
  const { user, updateSettings } = useContext(AuthContext);
  const [language, setLanguage] = useState(user?.language || 'en');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  const handleLanguageChange = async (e) => {
    const newLanguage = e.target.value;
    setLanguage(newLanguage);
    setSaving(true);
    setError('');
    setSaved(false);

    // Immediately switch UI language
    i18n.changeLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);

    try {
      await updateSettings({ language: newLanguage });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      // Revert on error
      i18n.changeLanguage(language);
      localStorage.setItem('language', language);
      setLanguage(language);
      setError(err.response?.data?.error || t('common.error'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="settings-page">
      <AppHeader />

      <div className="settings-container">
        <div className="settings-card">
          <h2>{t('settings.title')}</h2>

          {error && <div className="error-message">{error}</div>}
          {saved && <div className="success-message">{t('settings.saved')}</div>}

          <div className="settings-section">
            <div className="setting-item">
              <div className="setting-label">
                <label htmlFor="language">{t('settings.language')}</label>
                <p className="setting-description">{t('settings.languageDescription')}</p>
              </div>
              <div className="setting-control">
                <select
                  id="language"
                  value={language}
                  onChange={handleLanguageChange}
                  disabled={saving}
                  className="language-select"
                >
                  <option value="en">{t('languages.en')}</option>
                  <option value="pl">{t('languages.pl')}</option>
                </select>
                {saving && <span className="saving-indicator">{t('common.saving')}</span>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
